import Vue from 'vue'

// Shared reactive state for the gallery category filter.
// activeFilter is one of: null | 'adventure' | 'motorcycle' | 'creator'
export const filterStore = Vue.observable({
  activeFilter: null,
})

export function setFilter(filter) {
  filterStore.activeFilter = filter
}

export function toggleFilter(filter) {
  filterStore.activeFilter = filterStore.activeFilter === filter ? null : filter
}

export function clearFilter() {
  filterStore.activeFilter = null
}
